module.exports = __webpack_public_path__ + "img/773012_AE5124_4D1908_340F04-256px.84964f04.png";